import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getAuth } from "../api";
import { LOGIN_PATH } from "../../lib/session";

// Rota que só renderiza com sessão. Sem token, redireciona ANTES de montar menu/layout
// (antes o portal piscava a tela interna e só depois o Preloader mandava para o login).
export default function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        getAuth().auth ? <Component {...props} /> : <Redirect to={{ pathname: LOGIN_PATH, state: { from: props.location } }} />
      }
    />
  );
}
